var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mainapp",attrs:{"id":"mainapp"}},[_c('div',{attrs:{"id":"app"}},[_c('CB',{attrs:{"lang":_vm.lang,"region":_vm.region,"name":_vm.name,"birthdate":_vm.birthdate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }